import {PaginationParams} from "./../../helpers/api";
import {PageableModel} from "../../common/models/table";
import {AlertModel} from "../models/alert";
import {AxiosResponse} from "axios";
import http from "../../common/services/httpService";
import {Api, apiUrls} from "../../helpers/api";
import {HttpErrorModel} from "../../common/models/httpError";

export class AlertsService {
    private static baseUrl = apiUrls.alerts.alerts;

    public static async getAll(paginationParams: PaginationParams): Promise<AxiosResponse<PageableModel<AlertModel>>> {
        const url = Api.addParams(Api.getUrl(this.baseUrl), "query=type:!:SUCCESS");
        return await http.get(`${Api.addPaginationParams(url, paginationParams)}`);
    }

    public static async readAlert(id: string): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.patch(`${Api.getUrl(this.baseUrl)}/${id}/read`);
    }

    public static async resolveAlert(id: string): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.patch(`${Api.getUrl(this.baseUrl)}/${id}/resolve`);
    }

    public static async getCountOfUnreadAlerts(): Promise<AxiosResponse<{ count: number }>> {
        return await http.get(Api.getUrl(apiUrls.alerts.unreadAlertsCount));
    }

    public static async getUnreadAlerts(): Promise<AxiosResponse<PageableModel<AlertModel>>> {
        const url = Api.getUrl(apiUrls.alerts.unreadAlerts);
        const params = "query=type:!:SUCCESS&size=3";
        return await http.get(`${Api.addParams(url, params)}`);
    }
}
